<ng-content select=".before-burger-button-wrapper"></ng-content>
<app-burger-button-wrapper InvertedBurgerButton>
    <ng-content></ng-content>
</app-burger-button-wrapper>
